import React from 'react';
import { useParams } from 'react-router-dom';

import CollaboratorRatesTable from '../components/tables/CollaboratorRatesTable';

const CompanyTemporalRatesPage: React.FC = () => {
  const { companyId } = useParams();
  return <CollaboratorRatesTable companyId={Number(companyId)} hideCompanyColumn />;
};

export default CompanyTemporalRatesPage;
